
  /**
   * jQuery BASE64 functions
   *
   *  <code>
   *    Encodes the given data with base64.
   *    String $.base64Encode ( String str )
   *    <br />
   *    Decodes a base64 encoded data.
   *    String $.base64Decode ( String str )
   *  </code>
   *
   * Encodes and Decodes the given data in base64.
   * This encoding is designed to make binary data survive transport through transport layers that are not 8-bit clean, such as mail bodies.
   * Base64-encoded data takes about 33% more space than the original data.
   * This javascript code is used to encode / decode data using base64 (this encoding is designed to make binary data survive transport through transport layers that are not 8-bit clean). Script is fully compatible with UTF-8 encoding. You can use base64 encoded data as simple encryption mechanism.
   * If you plan using UTF-8 encoding in your project don't forget to set the page encoding to UTF-8 (Content-Type meta tag).
   * This function orginally get from the WebToolkit and rewrite for using as the jQuery plugin.
   *
   * Example
   *  Code
   *    <code>
   *      $.base64Encode("I'm Persian.");
   *    </code>
   *  Result
   *    <code>
   *      "SSdtIFBlcnNpYW4u"
   *    </code>
   *  Code
   *    <code>
   *      $.base64Decode("SSdtIFBlcnNpYW4u");
   *    </code>
   *  Result
   *    <code>
   *      "I'm Persian."
   *    </code>
   *
   * @alias Muhammad Hussein Fattahizadeh < muhammad [AT] semnanweb [DOT] com >
   * @link http://www.semnanweb.com/jquery-plugin/base64.html
   * @see http://www.webtoolkit.info/
   * @license http://www.gnu.org/licenses/gpl.html [GNU General Public License]
   * @param {jQuery} {base64Encode:function(input))
   * @param {jQuery} {base64Decode:function(input))
   * @return string
   */

  (function($){

    var keyString = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    var uTF8Encode = function(string) {
      string = string.replace(/\x0d\x0a/g, "\x0a");
      var output = "";
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
          output += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
          output += String.fromCharCode((c >> 6) | 192);
          output += String.fromCharCode((c & 63) | 128);
        } else {
          output += String.fromCharCode((c >> 12) | 224);
          output += String.fromCharCode(((c >> 6) & 63) | 128);
          output += String.fromCharCode((c & 63) | 128);
        }
      }
      return output;
    };

    var uTF8Decode = function(input) {
      var string = "";
      var i = 0;
      var c = c1 = c2 = 0;
      while ( i < input.length ) {
        c = input.charCodeAt(i);
        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        } else if ((c > 191) && (c < 224)) {
          c2 = input.charCodeAt(i+1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        } else {
          c2 = input.charCodeAt(i+1);
          c3 = input.charCodeAt(i+2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
        }
      }
      return string;
    }

    $.extend({
      base64Encode: function(input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = uTF8Encode(input);
        while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;
          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }
          output = output + keyString.charAt(enc1) + keyString.charAt(enc2) + keyString.charAt(enc3) + keyString.charAt(enc4);
        }
        return output;
      },
      base64Decode: function(input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
          enc1 = keyString.indexOf(input.charAt(i++));
          enc2 = keyString.indexOf(input.charAt(i++));
          enc3 = keyString.indexOf(input.charAt(i++));
          enc4 = keyString.indexOf(input.charAt(i++));
          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;
          output = output + String.fromCharCode(chr1);
          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }
        }
        output = uTF8Decode(output);
        return output;
      }
    });
  })(jQuery);

  /**
   * jQuery BASE64URL functions
   * http://en.wikipedia.org/wiki/Base64#Implementations_and_history
   *
   *  <code>
   *    Encodes the given data with base64url variant.
   *    String $.base64urlEncode( String str )
   *    <br />
   *    Decodes a base64url encoded data.
   *    String $.base64urlDecode( String str )
   *  </code>
   *
   *
   * @param {jQuery} {base64urlEncode:function(string))
   * @param {jQuery} {base64urlDecode:function(string))
   * @return string
   */
  (function($){
    $.extend({
      base64urlEncode: function( str ) {
        return $.base64Encode( str ).replace(/[+]/g,'-').replace(/[/]/g,'_').replace(/[=]+$/,'');
      },
      base64urlDecode: function( str ) {
        return $.base64Decode( str.replace(/[-]/g,'+').replace(/[_]/g,'/'));
      }
    });
  })(jQuery);


  /**
   * JQuery UI Combobox based on autocomplete.
   * Functions as a <select> element with option searching.
   * From http://stackoverflow.com/questions/5073612/jquery-ui-autocomplete-combobox-very-slow-with-large-select-lists
   * Improvements:
   *   - select.select() and select.change() event propagation added as necessary
   *   - changes to the selection in the original select are reflected in the combobox
   *   - the placeholder attribute is copied from the original select
   */

  (function($){
    $.widget( "ui.combobox", $.ui.autocomplete, {
          options: {
            /* override default values here */
            minLength: 0,
            /* the argument to pass to ajax to get the complete list */
            ajaxGetAll: {get: "all"},
            /* unique id of a target select */
            selectId: '',
            appendToHiddenClass: 'edit_item--hidden',
						customClasses: ''
          },

          _create: function(){
            if (this.element.is("SELECT")){
              this.options.selectId = this.element.prop('id');
              this._selectInit();
              return;
            }

            this._super();

            if (this.options.appendTo) {
              this.menu.element.addClass('ui-autocomplete--appended')
            }

            var input = this.element;
            input.addClass( "ui-widget ui-widget-content ui-corner-left" + (this.options.customClasses ? this.options.customClasses : '') );

            this.button = $( "<button class='ui-corner-right ui-button-icon' type='button' tabindex='-1' title='Show All Items'>&nbsp;</button>" )
                .insertAfter( input )
                .button({
                  icons: { primary: "ui-icon-triangle-1-s" },
                  text: false
                })
                .removeClass( "ui-corner-all" )
                .click(function(event) {
                  // close if already visible
                  if ( input.combobox( "widget" ).is( ":visible" ) ) {
                    input.combobox( "close" );
                    return;
                  }
                  // when user clicks the show all button, we display the cached full menu
                  var data = input.data('ui-combobox');
                  clearTimeout( data.closing );
                  if (!input.isFullMenu){
                    data._swapMenu();
                    input.isFullMenu = true;
                  }
                  // input/select that are initially hidden (display=none, i.e. second level menus),
                  //  will not have position cordinates until they are visible.
                  input.combobox( "widget" )
                      .css({display: "block"})
                      .position($.extend({ of: input },
                          data.options.position
                      ));
                  input.val('');
                  input.focus();
                  data._trigger( "open" );
                });

            // to better handle large lists, put in a queue and process sequentially
            $(document).queue(function(){
              var data = input.data('ui-combobox');
              if (Array.isArray(data.options.source)){
                $.ui.combobox.prototype._renderFullMenu.call(data, data.options.source);
              } else if (typeof data.options.source === "string") {
                $.getJSON(data.options.source, data.options.ajaxGetAll , function(source){
                  $.ui.combobox.prototype._renderFullMenu.call(data, source);
                });
              }else {
                $.ui.combobox.prototype._renderFullMenu.call(data, data.source());
              }
            });
          },

          /* initialize the full list of items, this menu will be reused whenever the user clicks the show all button */
          _renderFullMenu: function(source){
            var self = this,
                input = this.element,
                ul = input.data('ui-combobox').menu.element,
                lis = [];
            if(ul.children().length > 0){
              ul.empty();
            }
            ul.addClass(this.options.selectId);
            ul.addClass('ui-corner-all');
            source = this._normalize(source);
            input.data('ui-combobox').menuAll = input.data('ui-combobox').menu.element.clone(true).removeAttr('id').appendTo(ul.parent());
            for(var i=0; i<source.length; i++){
              var escaped_label = escapeHTML(source[i].label);
              var li = "<li class='ui-menu-item' role='menuitem'>";
              if (escaped_label.length > 0) {
                li += "<div class='ui-menu-item-wrapper ui-corner-all'><a tabindex='-1'>" + escaped_label + "</a></div>";
              }
              li += "</li>";
              lis.push(li);
            }
            ul.append(lis.join(""));

            if (!this.options.appendTo) {
              this._resizeMenu();
            }

            // setup the rest of the data, and event stuff
            setTimeout(function(){
              self._setupMenuItem.call(self, ul.children("li"), source );
            }, 0);
            input.isFullMenu = true;
          },

          /* incrementally setup the menu items, so the browser can remains responsive when processing thousands of items */
          _setupMenuItem: function( items, source ){
            var self = this,
                itemsChunk = items.splice(0, 500),
                sourceChunk = source.splice(0, 500);
            for(var i=0; i<itemsChunk.length; i++){
              $(itemsChunk[i])
                  .data('ui-autocomplete-item', sourceChunk[i])
            }
            if (items.length > 0){
              setTimeout(function(){
                self._setupMenuItem.call(self, items, source );
              }, 0);
            }else { // renderFullMenu for the next combobox.
              setTimeout(function() {
                $(document).dequeue();

                if (self.options.appendTo) {
                  $(self.options.appendTo).removeClass(self.options.appendToHiddenClass);
                }
              }, 0);
            }
          },

          /* overwrite. make the matching string bold */
          _renderItem: function( ul, item ) {
            var escaped_label = escapeHTML(item.label);
            var escaped_term = escapeHTML(this.term);

            var label = escaped_label.replace( new RegExp(
                "(?![^&;]+;)(?!<[^<>]*)(" + $.ui.autocomplete.escapeRegex(escaped_term) +
                ")(?![^<>]*>)(?![^&;]+;)", "gi"), "<strong>$1</strong>" );
            return $( "<li><div><a>" + label + "</a></div></li>" )
                .appendTo( ul );
          },

          /* overwrite. to cleanup additional stuff that was added */
          destroy: function() {
            if (this.element.is("SELECT")){
              if (this.input.data('ui-combobox') && this.input.data('ui-combobox').menuAll){
                this.input.data('ui-combobox').menuAll.remove();
              }
              this.input.remove();
              this.element.removeData().show();
              return;
            }

            this._super();
            // clean up new stuff
            this.element.removeClass( "ui-widget ui-widget-content ui-corner-left" );
            this.button.remove();
          },

          refresh: function() {
            var comboBox = this.input.data('ui-combobox');
            var source = comboBox.options.selectElement.children("option").map(function() {
              return this.hasAttribute('disabled')
                  ? {}
                  : { label: this.text ? this.text.trim() : '', option: this };
            }).toArray();
            comboBox.options.source = source;
            $.ui.combobox.prototype._renderFullMenu.call(comboBox, source);
            this.refreshSelected();
          },

          /* overwrite. to swap out and preserve the full menu */
          search: function( value, event){
            var input = this.element;
            if (input.isFullMenu){
              this._swapMenu();
              input.isFullMenu = false;
            }

            this._super(value, event);
          },

          _change: function( event ){
            if ( !this.selectedItem ) {
              var matcher = new RegExp( "^" + $.ui.autocomplete.escapeRegex( this.element.val() ) + "$", "i" );
              var match = null;

              for (var i = 0; i < this.options.source.length; i++) {
                var value = this.options.source[i];
                if (matcher.test(value.label)) {
                  match = value;
                  break;
                }
              }

              if (match && match.option.value !== ''){
                if (!match.option.selected) {
                  match.option.selected = true;
                  this.options.selectElement.change();
                }
              }else {
                // remove invalid value, as it didn't match anything
                this._updateInputValue(this.element, this.options.selectElement);
              }
            }

            this._super(event);
          },

          _swapMenu: function(){
            var input = this.element,
                data = input.data('ui-combobox'),
                tmp = data.menuAll;
            data.menuAll = data.menu.element.hide();
            data.menu.element = tmp;
          },

          /* build the source array from the options of the select element */
          _selectInit: function(){
            var abc = this;
            var select = this.element.hide();
            this.options.source = select.children( "option" /* [value!=''] */ ).map(function() {
              return { label: this.text ? this.text.trim() : '', option: this };
            }).toArray();
            var userSelectCallback = this.options.select;
            var userSelectedCallback = this.options.selected;
            this.options.select = function(event, ui){
              ui.item.option.selected = true;
              if (userSelectCallback) userSelectCallback(event, ui);
              // compatibility with jQuery UI's combobox.
              if (userSelectedCallback) userSelectedCallback(event, ui);
              select.change();
            };
            this.options.selectElement = select;
            this.input = $( "<input>" )
                .insertAfter( select )
                .combobox(this.options)
                .click(function() {
                  this.nextSibling.click();
								});
            this._updateInputValue(this.input, select);
            if (this.options.readonly) {
              this.input.attr('readonly', true)
            }
            // copy placeholder over
            if (select.attr('placeholder') !== ''){
              this.input.attr('placeholder', select.attr('placeholder'));
            }
            // catch changes to the hidden dropdown
            select.change(function( event, ui ) {
              abc._updateInputValue(abc.input, select);
            });
          },

          _updateInputValue: function(input, select) {
            var selected = select.children( ":selected" );
            var text = selected.text();
            input.val((selected && selected.val() && text) ? text.trim() : '');
          },

          refreshSelected: function(){
            var select = $(this.options.selectElement),
                input = select.data('ui-combobox').input;
            this._updateInputValue(input, select);
          }
        }
    );
  })(jQuery);

  /**
 * Some functionality of jQuery UI 1.8 which we used were removed in jQuery UI 1.10.
 * So during jQuery UI update we had to write our own code to retain all these features.
 *
 * The code below extends JQuery UI Tabs widget functionality with following things:
 *  - spinner
 *  - cache
 *  - cookie
 *  Please see http://api.jqueryui.com/1.8/tabs/#option-cookie to get more details about how they works.
 *
 *  All these features are turned on by default, but it is possible to turn them off by setting axSpinner,
 *  axCache or axCookie option to false in .tabs(...) init function.
 *
 */

JQUERY_UI_TAB_CACHE_KEY = 'cache.tabs';

(function($) {
  var labelKey = 'label.tabs';

  function tabWasCached($tab) {
    return !!$tab.data(JQUERY_UI_TAB_CACHE_KEY)
  }
  function markTabAsCached($tab) {
    $tab.data(JQUERY_UI_TAB_CACHE_KEY, true);
  }
  function markTabAsNotCached($tab) {
    $tab.removeData(JQUERY_UI_TAB_CACHE_KEY);
  }

  $.widget("ui.tabs", $.ui.tabs, {
        axMultiPageWasCalled: false,
        options: {
          axSpinner: _loading_tab_label,
          axCache: true,
          axMultiPage: false,
          axCookie: true,
          axAlwaysReloadedTabs: []
        },
        _callFuncSafely: function (target, args) {
          if (target && (typeof target === 'function')) {
            target.apply(this, args);
          }
        },
        _addCacheFunctionality: function() {
          var that = this;
          var beforeLoadCallback = this.options.beforeLoad;
          this.options.beforeLoad = function(event, ui) {
            var tabOptions = $(event.target).tabs('option')
            var tabsToReload = tabOptions.axAlwaysReloadedTabs;
            var needReload = tabsToReload.indexOf(ui.tab.data('uiTabsAriaControls')) !== -1;
            if (needReload) {
              markTabAsNotCached(ui.tab);
            }
            if (tabWasCached(ui.tab)) {
              event.preventDefault();
            } else {
              ui.jqXHR.done(function() {
                markTabAsCached(ui.tab);
              });
            }

            that._callFuncSafely(beforeLoadCallback, arguments);
          };
        },
        _addSpinnerFunctionality: function() {
          var that = this;
          var beforeLoadCallback = this.options.beforeLoad;
          this.options.beforeLoad = function(event, ui) {
            if (!tabWasCached(ui.tab) && !event.isDefaultPrevented()) {
              var $span = ui.tab.find('span');
              var text = $(event.target).tabs('option').axSpinner;
              $span.data(labelKey, $span.html()).html(text);
            }

            that._callFuncSafely(beforeLoadCallback, arguments);
          };

          var loadCallback = this.options.load;
          this.options.load = function(event, ui) {
            var $span = ui.tab.find('span');
            $span.html($span.data(labelKey)).removeData(labelKey);

            that._callFuncSafely(loadCallback, arguments);
          };
        },
        _addCookiesFunctionality: function() {
          var that = this;
          var cookieName = this.element.attr('id');
          // the tab's element should have an id or cookie feature won't work
          if (!cookieName) {
            return;
          }
          cookieName = 'tabs-cookie-' + cookieName;

          this.options.active = $.cookie(cookieName);

					//TODO return back to activate callback after using only x360 UI
          var beforeActivateCallback = this.options.beforeActivate;
          this.options.beforeActivate = function(event, ui) {
            $.cookie(cookieName, ui.newTab.index(), {
              expires: 90,
              secure: true
            });

            that._callFuncSafely(beforeActivateCallback, arguments);
          };
        },
        _addMultiPageFunctionality: function() {
          const that = this;
          const exactUrl = this.options.axMultiPageFunctionality.getRealUrl();
          const selectedTab = this.options.axMultiPageFunctionality.getRealTab(exactUrl);
          if (selectedTab) {
            this.options.active = this.element.find('li.'+ selectedTab).index();
          }

          const beforeLoadCallback = this.options.beforeLoad;
          this.options.beforeLoad = function (event, ui) {
            if (that.options.axMultiPage && that.options.axMultiPageFunctionality.multiPageCallback && !that.axMultiPageWasCalled) {
              that.axMultiPageWasCalled = true;
              that.options.axMultiPageFunctionality.multiPageCallback(event, exactUrl, 'li.'+ selectedTab);
            } else {
              that._callFuncSafely(beforeLoadCallback, arguments);
            }
          };
        },
        _create: function() {
          // if a user define 'active' tab option, cookie and multi-page feature won't work
          if (this.options.axMultiPage && this.options.axMultiPageFunctionality && this.options.active === null && !this.axMultiPageWasCalled) {
            this._addMultiPageFunctionality();
          }
          if (this.options.axCookie && this.options.active === null) {
            this._addCookiesFunctionality();
          }
          if (this.options.axSpinner) {
            this._addSpinnerFunctionality();
          }
          if (this.options.axCache) {
            this._addCacheFunctionality();
          }

          this._super();
        }
      }
  );
})(jQuery);

/*jslint browser: true */ /*global jQuery: true */
